import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Button } from "components";
import { defaultSplitInformation } from "mappers";
import { AgentType, ResidualsSplitProfileType } from "types";

import { OverridePrimarySplitInformation } from "./overridePrimarySplitInformation";
import { OverrideSecondarySplitInformation } from "./overrideSecondarySplitInformation";

import styles from "./../../splitProfile.module.scss";

type OverrideProps = {
	isLoading: boolean;
	setToggleAgentSelect: Function;
	toggleAgentSelect: boolean;
	isEditing: boolean;
	splitProfile: ResidualsSplitProfileType;
	currentAgent?: AgentType;
};

export const Override = ({
	isLoading,
	setToggleAgentSelect,
	toggleAgentSelect,
	isEditing,
	splitProfile,
	currentAgent,
}: OverrideProps) => {
	const { control } = useFormContext();
	const { fields, append, remove } = useFieldArray({
		control,
		name: "secondarySplitInformation",
		keyName: "ide",
	});

	useEffect(() => {
		if (fields.length === 0) {
			append(defaultSplitInformation);
		}
	}, [append, fields.length, remove]);

	const addSplitInformation = () => {
		append(defaultSplitInformation);
	};

	const removeSplitInformation = index => {
		remove(index);
	};

	return (
		<>
			<OverridePrimarySplitInformation
				name="primarySplitInformation"
				title="Primary Split Information"
				splitInfo={splitProfile?.primarySplitInformation}
				currentAgent={currentAgent}
				isLoading={isLoading}
				isEditing={isEditing}
			/>
			{fields.map((splitInfo: { [key: string]: any }, index) => {
				return (
					<OverrideSecondarySplitInformation
						key={splitInfo.ide}
						name={`secondarySplitInformation.${index}`}
						title="Secondary Split Information"
						index={index}
						splitInfo={splitInfo}
						isLoading={isLoading}
						setToggleAgentSelect={setToggleAgentSelect}
						toggleAgentSelect={toggleAgentSelect}
						onRemoveSplitInfo={removeSplitInformation}
						isEditing={isEditing}
					/>
				);
			})}

			<div className={styles.wrappAddButton}>
				<Button
					value="Add Secondary Split Information"
					onClick={addSplitInformation}
					variant="secondary"
				/>
			</div>
		</>
	);
};
